import React, { Component } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import CameraAlt from "@material-ui/icons/CameraAlt";
import Delete from "@material-ui/icons/Delete";
import Done from "@material-ui/icons/Done";
import useStyles from "../appointments/create/css/styles";
import { GetAdminSettingValue } from "../appointments/create/api/index"; //FB 7264 DK

//Update log
// FB 6025 BR   04/26/2022    PE - Import Photos through QR code scan from smartphone
// FB 6347 GS   12/23/2022    Increased the QR code picture capturing screen size
// FB 6963 AS   06/11/2023    Display result/error message
// FB 7264 DK   08/28/2023    Need an Admin Setting to Specify The Resolution of QR Camera Images

export default class Camera extends Component {

    constructor(props) {
        super(props);
        //FB 6347 BEGIN
        // FB 7264 DK Begin--Commented device width
        // this.deviceWidth = "0px";
        // this.deviceHeight = "0px";
        // if (window.innerWidth <= 768) {
        //     this.deviceWidth = "270px";
        //     this.deviceHeight = "350px";
        // }
        // else {
        //     this.deviceWidth = "700px";
        //     this.deviceHeight = "900px";
        // }
        //FB 6347 END
        this.state = {
            disableUpload: "none",
            disableDelete: "none",
            maxWidth: 0,
            maxHeight: 0,
        };
        // FB 7264 DK End
    }

    // FB 7264 DK Begin
    async componentDidMount() {
        const cameras = await navigator.mediaDevices.enumerateDevices();
        this.processDevices(cameras);

        const maxWidth = await GetAdminSettingValue("Image_Resolution");

        if (maxWidth) {
            this.setState({ maxWidth: parseInt(maxWidth, 10) }, async () => {
                const cameras = await navigator.mediaDevices.enumerateDevices();
                this.processDevices(cameras);
            });
        }
    }

    processDevices(devices) {
        devices.forEach(device => {
            console.log(device.label);
            this.setDevice(device);
        });
    }

    async setDevice(device) {
        const { deviceId } = device;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'environment', width: { max: this.state.maxWidth }, height: { max: this.state.maxWidth } } });
        this.videoPlayer.srcObject = stream;
        this.videoPlayer.play();
    }

    takePhoto = () => {
        this.props.successMessage = "";
        this.props.errorMessage = "";
        const { sendFile } = this.props;
        const context = this.canvas.getContext('2d');
        this.canvas.setAttribute("width", this.videoPlayer.videoWidth);
        this.canvas.setAttribute("height", this.videoPlayer.videoHeight);
        context.drawImage(this.videoPlayer, 0, 0, this.videoPlayer.videoWidth, this.videoPlayer.videoHeight);
        this.setState({ disableUpload: "flex" });
        this.setState({ disableDelete: "flex" });
    };

    dataURLtoBlob = (dataURL) => {
        return new Promise((resolve, reject) => {
            const byteString = atob(dataURL.split(',')[1]);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([int8Array], { type: 'image/png' });
            resolve(blob);
        });
    }
    
    UploadPhoto = () => {
        this.props.callBack(this.canvas.toDataURL('image/png').split(';base64,')[1]);
        this.DeletePhoto();
        this.setState({ disableUpload: "none" });
        this.setState({ disableDelete: "none" });
    }

    DeletePhoto = () => {
        const context = this.canvas.getContext('2d');
        context.clearRect(0, 0, this.videoPlayer.videoWidth, this.videoPlayer.videoHeight);
        this.setState({ disableUpload: "none" });
        this.setState({ disableDelete: "none" });
    }
    // FB 7264 DK End

    render() {
        return (
            <div className="c-camera-feed"
            // FB 7264
            // FB 6347 GS BEGIN
            // style={{
            //     paddingTop: (window.innerWidth <= 768) ? "0px" : "100px",
            //     paddingBottom: (window.innerWidth <= 768) ? "0px" : "200px",
            // }}
            >
                {/* FB 6347 GS END  */}
                <br />
                <Grid lg={12}
                    md={12}
                    sm={12} xs={12} style={{
                        // FB 7264
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex"
                    }}>
                    {/* FB 6347 */}
                    {/* FB 7264 DK  Begin*/}
                    <div>
                        <video playsInline ref={ref => (this.videoPlayer = ref)} style={{ width: "480px" }} ></video>
                    </div>
                    {/* FB 7264 DK  End*/}
                </Grid>
                <br />
                {/* FB 6347 */}
                {/* FB 7264 */}
                <Grid container spacing={6} style={{ justifyContent: "center" }}>
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            startIcon={<CameraAlt />}
                            component="label"
                            onClick={this.takePhoto}
                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                        >
                        </Button>
                    </Grid>
                    <br />
                    <br />
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            component="label"
                            startIcon={<Done />}

                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                display: this.state.disableUpload,
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                            onClick={this.UploadPhoto}

                        >
                        </Button>
                    </Grid>
                    <br />
                    <br />
                    <Grid
                        item
                        xs={2}
                        md={1}
                        lg={1}
                    >
                        <Button
                            component="label"
                            startIcon={<Delete />}
                            style={{
                                backgroundColor: "#18a2b8",
                                color: "white",
                                borderRadius: "15px",
                                width: "20px",
                                display: this.state.disableDelete,
                                "&:hover": {
                                    backgroundColor: "#46B4C6",
                                }
                            }}
                            onClick={this.DeletePhoto}
                        >
                        </Button>
                    </Grid>
                </Grid>

                {/* FB 6963 display upload success or error message */}

                {this.props.successMessage && <div style={{ color: "#18a2b8", marginTop: "1.5rem", textAlign: "center" }} >{this.props.successMessage}</div>}

                {this.props.errorMessage && <div style={{ color: "#f50057", marginTop: "1.5rem", textAlign: "center" }} >{this.props.errorMessage}</div>}

                <br />
                <Grid lg={12}
                    md={12}
                    sm={12} xs={12} style={{
                        // FB 7264
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        //paddingTop: (window.innerWidth <= 768) ? "0px" : "30%"  // FB 6347    //FB 7264
                    }}>
                    {/* FB 6347 */}
                    {/* FB 7264 DK  */}
                    <canvas ref={ref => (this.canvas = ref)}></canvas>
                    {/* /* <image style={{width:"360px",height:"360px"}} src={this.canvas?.toDataURL('image/png')}/> */}
                </Grid>
            </div>
        );
    }
}